var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-0 dinlineb prelative" }, [
    _c(
      "div",
      {
        staticClass:
          "avatar-wrapper dinlineb prelative valign-middle pr-8 br-1 cpointer",
        on: { click: _vm.toggleList }
      },
      [
        _vm.currentstaff.avatar
          ? _c(
              "div",
              {
                staticClass: "avatar avatar-big",
                class: {
                  "avatar-picture": _vm.currentstaff.avatar.type == "picture"
                }
              },
              [
                _vm.currentstaff.avatar.type == "picture"
                  ? _c("img", { attrs: { src: _vm.currentstaff.avatar.value } })
                  : _c("span", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.currentstaff.avatar.value) +
                          "\n            "
                      )
                    ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "staff-detail dinlineb valign-middle ml-3" }, [
          _c("div", { staticClass: "staff-name bold ellipsis" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$filters.shortName(_vm.currentstaff.fullName)) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "staff-job gray-60" }, [
            _vm._v(_vm._s(_vm.currentstaff.position))
          ])
        ]),
        _vm._v(" "),
        _vm.nbStaffs > 1
          ? _c("i", {
              staticClass:
                "fa icon-caret-down primary-50 fs-3 mt-1 pabsolute top-right mr-5 mt-1"
            })
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.displayList,
            expression: "displayList"
          }
        ],
        staticClass: "staff-list pabsolute span_12 well px-3 pt-4"
      },
      [
        _c(
          "div",
          {
            staticClass: "valign-middle prelative pb-5 pr-3 bb-1 cpointer",
            on: { click: _vm.toggleList }
          },
          [
            _vm.currentstaff.avatar
              ? _c(
                  "div",
                  {
                    staticClass: "avatar avatar-big",
                    class: {
                      "avatar-picture":
                        _vm.currentstaff.avatar.type == "picture"
                    }
                  },
                  [
                    _vm.currentstaff.avatar.type == "picture"
                      ? _c("img", {
                          attrs: { src: _vm.currentstaff.avatar.value }
                        })
                      : _c("span", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.currentstaff.avatar.value) +
                              "\n                "
                          )
                        ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "staff-detail dinlineb valign-middle ml-3" },
              [
                _c("div", { staticClass: "staff-name bold ellipsis" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$filters.shortName(_vm.currentstaff.fullName)
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "staff-job gray-60" }, [
                  _vm._v(_vm._s(_vm.currentstaff.position))
                ])
              ]
            ),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "fa icon-caret-top-fillout primary-50 fs-3 pabsolute top-right mt-1"
            })
          ]
        ),
        _vm._v(" "),
        _c("el-input", {
          staticClass: "mt-3",
          attrs: {
            placeholder: _vm.$t.__("common.actions.search"),
            clearable: "",
            size: "medium"
          },
          model: {
            value: _vm.search,
            callback: function($$v) {
              _vm.search = $$v
            },
            expression: "search"
          }
        }),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "m-0 list-staffs ov-auto" },
          _vm._l(_vm.staffsList, function(staff) {
            return _c("li", { key: staff.id }, [
              _c(
                "a",
                {
                  staticClass: "block p-2 my-2 hover-gray-0-bkg",
                  attrs: { href: "/staff/" + staff.id }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "avatar",
                      class: {
                        "avatar-picture": staff.avatar.type == "picture"
                      }
                    },
                    [
                      staff.avatar.type == "picture"
                        ? _c("img", { attrs: { src: staff.avatar.value } })
                        : _c("span", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(staff.avatar.value) +
                                "\n                        "
                            )
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "staff-detail dinlineb valign-middle ml-3" },
                    [
                      _c("div", { staticClass: "fs-3 gray-100" }, [
                        _vm._v(_vm._s(staff.fullName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "staff-job gray-60" }, [
                        _vm._v(_vm._s(staff.position))
                      ])
                    ]
                  )
                ]
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "block acenter mt-3 fs-3 semibold",
            attrs: { href: "/staffs" }
          },
          [_vm._v(_vm._s(_vm.$l10n.__("Voir tous les collaborateurs")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }